import React from "react";
import { Link, Tooltip } from "@mui/material";
import SchoolIcon from "@mui/icons-material/School";
import GitHubIcon from "@mui/icons-material/GitHub";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import TwitterIcon from "@mui/icons-material/Twitter";

function SocialIcon(props) {
    const { link, icon, label } = props;

    const renderIcon = () => {
        const lowerLabel = (label || "").toLowerCase();
        const lowerIcon = (icon || "").toLowerCase();

        const iconStyle = { fontSize: "2.2rem", transition: "all 0.2s ease" };

        if (lowerLabel.includes("scholar") || lowerIcon.includes("graduation")) {
            return <SchoolIcon sx={iconStyle} />;
        } else if (lowerLabel.includes("github") || lowerIcon.includes("github")) {
            return <GitHubIcon sx={iconStyle} />;
        } else if (lowerLabel.includes("linkedin") || lowerIcon.includes("linkedin")) {
            return <LinkedInIcon sx={iconStyle} />;
        } else if (lowerLabel.includes("twitter") || lowerLabel.includes("x") || lowerIcon.includes("twitter")) {
            return <TwitterIcon sx={iconStyle} />;
        } else {
            return <i className={icon} aria-hidden="true" style={{ fontSize: "2.2rem" }} />;
        }
    };

    return (
        <Tooltip title={label || "Social link"} arrow>
            <Link
                href={link}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={label}
                sx={{
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#3b82f6 !important",
                    p: 0.5,
                    transition: "all 0.2s ease-in-out",
                    "&:hover": {
                        color: "#1d4ed8 !important",
                        transform: "translateY(-3px) scale(1.12)"
                    }
                }}
            >
                {renderIcon()}
            </Link>
        </Tooltip>
    );
}

export default SocialIcon;
